

export default function PersonalForm({ formData, handleInputChange,errors }) {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };
    return (
        <div>
            <h3>Personal Information</h3>

            {/* Date of Birth */}
            <div className="single-box">
                <div className="inner-title pt_15">
                    <label htmlFor="Date_of_birth"><p>Date of Birth</p></label>
                </div>
                <div className="date-box clearfix">
                    <input
                        type="date"
                        
                        name="Date_of_birth"
                        required
                        value={formData.Date_of_birth || ""}

                        style={{
                            padding: "5px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            width: "20%",
                        }}
                        max="2007-12-31"
                        onChange={handleChange}
                    />
                    
                </div>
                <span className="error-message">{errors.Date_of_birth}</span>
            </div>

            {/* Social Security Number */}
            <div className="single-box">
                <div className="inner-title">
                    <label htmlFor="Social_security"><p>Social Security Number</p></label>
                </div>
                <input
                    type="text"
                    id="Social_security"
                    name="Social_security"
                    required
                    value={formData.Social_security || ""}
                    onChange={handleChange}
                />
                <span className="error-message">{errors.Social_security}</span>
            </div>

            {/* Driver's License Number */}
            <div className="single-box">
                <div className="inner-title">
                    <label htmlFor="Drivers_license"><p>Driver's License Number</p></label>
                </div>
                <input
                    type="text"
                    id="Drivers_license"
                    name="Drivers_license"
                    required
                    value={formData.Drivers_license || ""}
                    onChange={handleChange}
                />
                <span className="error-message">{errors.Drivers_license}</span>
            </div>

            <div className="row">
                {/* Credit Card Information */}
                <div className="col-xl-6">
                    <div className="single-box">
                        <div className="inner-title">
                            <label htmlFor="Credit_card"><p>Credit Card Information</p></label>
                        </div>
                        <input
                            type="text"
                            id="Credit_card"
                            name="Credit_card"
                            required
                            value={formData.Credit_card || ""}
                            onChange={handleChange}
                        />
                        <span className="error-message">{errors.Credit_card}</span>
                    </div>
                </div>

                {/* Expiration Date */}
                <div className="col-xl-3">
                    <div className="single-box">
                        <div className="inner-title">
                            <label htmlFor="Exp"><p>Exp</p></label>
                        </div>
                        <input
                            type="text"
                            id="Exp"
                            name="Exp"
                            placeholder="MM/YY"
                            required
                            value={formData.Exp || ""}
                            onChange={handleChange}
                        />
                        <span className="error-message">{errors.Exp}</span>
                    </div>
                </div>

                {/* CVV */}
                <div className="col-xl-3">
                    <div className="single-box">
                        <div className="inner-title">
                            <label htmlFor="CVV"><p>CVV</p></label>
                        </div>
                        <input
                            type="text"
                            id="CVV"
                            name="CVV"
                            required
                            value={formData.CVV|| ""}
                            onChange={handleChange}
                            
                        />
                        <span className="error-message">{errors.CVV}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
